import type { DischargeReasonApi, UserDischargeApi } from "@/Modules/Customers/Model/Api/Discharge";
import type { PaginatedApiResponse } from "@/Modules/App/Models/Api/PaginatedApiResponse";

import TherapySideApiService from "@/Services/TherapyApi/utils/TherapyApi";

class UserDischargeAPIConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  async getUserDischarge(uuid: string): Promise<UserDischargeApi> {
    const res = await this.ApiService.get<void, PaginatedApiResponse<UserDischargeApi>>({
      endpoint: `/v1.0/discharge/${uuid}`,
      responseParams: { raw: true },
    });

    return res.body[0];
  }

  async getReasons(): Promise<DischargeReasonApi[]> {
    return this.ApiService.get<void, DischargeReasonApi[]>({
      endpoint: "/v1.0/discharge/reasons",
    });
  }
}

export default UserDischargeAPIConnector;
